import React from 'react';
import {
  filterDecimalKeyDown,
  filterIntegerKeyDown,
  sanitizeDecimalString,
  sanitizeIntegerString
} from '../utils/numericInput';

/**
 * Controlled numeric field without alphabetic input: uses type="text" + inputMode + sanitization.
 * @param {'decimal'|'integer'} variant - integer = digits only; decimal = optional minus + one decimal sep
 */
const NumericInput = React.forwardRef(function NumericInput(
  { value, onChange, onKeyDown, className = '', variant = 'decimal', ...rest },
  ref
) {
  const isInt = variant === 'integer';
  const sanitize = isInt ? sanitizeIntegerString : sanitizeDecimalString;
  const filterKey = isInt ? filterIntegerKeyDown : filterDecimalKeyDown;

  const handleChange = (e) => {
    if (!onChange) return;
    const cleaned = sanitize(e.target.value);
    if (cleaned !== e.target.value) {
      onChange({ ...e, target: { ...e.target, value: cleaned } });
    } else {
      onChange(e);
    }
  };

  const handleKeyDown = (e) => {
    filterKey(e);
    onKeyDown?.(e);
  };

  const { type, min, max, step, pattern, ...safeRest } = rest;

  return (
    <input
      ref={ref}
      type="text"
      inputMode={isInt ? 'numeric' : 'decimal'}
      autoComplete="off"
      spellCheck={false}
      value={value ?? ''}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      className={className}
      {...safeRest}
    />
  );
});

export default NumericInput;
